import { useEffect, useState } from 'react'
import { Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Table } from 'reactstrap';
import { CancelIcon, DeleteIcon } from '../../../common/icons';
import useCheckGroup from '../../../../hook/useCheckGroup';
import { IPositionAssignmentLight } from '../../../../types/individual';
import OmsToolTip from '../../../common/oms-tooltip/oms-tooltip';
import Button from '../../../common/button';

type  RemoveActingLinkDialogProg={
    title: string;
    individualName:string;
    fullPositionName:string;
    isOpen: boolean;
    toggle: ()=>void;
    onRemove : (assignments:IPositionAssignmentLight[])=>void;
    list:IPositionAssignmentLight[];
}

const RemoveActingLinkDialog = (props: RemoveActingLinkDialogProg) => {

    const {isOpen, toggle, onRemove, title, individualName,fullPositionName, list} = props
    const {checkGroup: checkGroup} = useCheckGroup<number>()
    const [groupCheckable,setGroupCheckable] = useState<boolean>(true)

    useEffect(()=> {
        //console.log("list:",list)
        checkGroup.init(list?.map((e: IPositionAssignmentLight) => e.assignmentId))
        const scopeList = list?.filter((e: IPositionAssignmentLight) => e.isScope)
        setGroupCheckable(scopeList&&scopeList.length>0)
    },[list])

    const onClickOk = () => {
        toggle()
        const assignmentIds = checkGroup.getCheckedValues()
        const assignments = list.filter((item:IPositionAssignmentLight)=>{
            return assignmentIds.includes(item.assignmentId)
        })
        onRemove(assignments)
    }
     
    return <div className='confirm'>
         <Modal id={'remove-acting-link'} role="alertdialog" centered={true} style={{maxWidth: '800px'}} isOpen={isOpen} toggle={toggle} backdrop="static" autoFocus={false}>
            <ModalHeader cssModule={{'modal-title':'w-100 text-center'}} toggle={toggle} tag={'h2'}>{title}</ModalHeader>
            <ModalBody className={'centered-content'}>
                <div dangerouslySetInnerHTML={{ __html: `<b>${individualName}</b> will be removed from their home position: <b>${fullPositionName}</b>.<br/><br/>Please select which other positions the individual should be removed from. If the position is outside of your scope (greyed-out), please contact the appropriate ministry coordinator.<br/><br/>` }} />
                <Table striped className="assignment-table">
                    <thead>
                        <tr>
                            <th style={{width:'5%'}}>
                            <Label for="checkAll-assignment" className="hidden-text" role="region" aria-label="Select All">Select All</Label>
                            <Input id="checkAll-assignment" aria-label="Select All" className="form-check-input" type='checkbox'disabled={!groupCheckable}
                                checked={checkGroup.isAllChecked()} onChange={checkGroup.onCheckAll} autoFocus={true}/>
                            </th>
                            <th style={{width:'35%'}}><div role="region" aria-label="Position Title">Position Title</div></th>
                            <th style={{width:'30%'}}><div role="region" aria-label="Relationship Type">Assignment Type</div></th>
                            <th style={{width:'30%'}}><div role="region" aria-label="Related Organization">Related Organization</div></th>
                        </tr>
                    </thead>
                    <tbody>
                    {
                        list.map((assignment:IPositionAssignmentLight,index:number)=>(
                            <tr key={index} >
                                <td>
                                    <div>
                                        <Input
                                            className="form-check-input"
                                            type="checkbox"
                                            value={index}
                                            id={`checkboxNoLabel-${index}`}
                                            checked={checkGroup.isChecked(assignment.assignmentId)}
                                            onChange={event=>checkGroup.onCheck(event, assignment.assignmentId)}
                                            aria-label={`select ${assignment.positionTitle}`}
                                            disabled={!assignment.isScope}
                                        />
                                    </div>
                                </td>
                                <td>{assignment.positionTitle}</td>
                                <td>{assignment.relationshipType}</td>
                                <td>
                                    <OmsToolTip positionId={assignment.positionId}>
                                        {assignment.relatedOrganization}
                                    </OmsToolTip>
                                </td>

                            </tr>
                        ))
                    }
                    </tbody>
                </Table>
            </ModalBody>
            <ModalFooter>
                <Button color="danger" onClick={onClickOk} /*disabled={checkGroup.isNoneChecked()}*/>
                    <DeleteIcon/> Remove
                </Button>
                <Button color="secondary" onClick={toggle}>
                    <CancelIcon/> Cancel
                </Button>
            </ModalFooter>
        </Modal>
        </div>
}

export default RemoveActingLinkDialog;

